import ProfilePage from "./ProfilePage";

export default ProfilePage;

export * from "./ProfilePage";
